export default __webpack_public_path__ + "static/media/img--interiors-4.5d17083a.jpg";